// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kB","show":"kC","dark":"kD","top":"kE","bottom":"kF","left":"kG","right":"kH"};